import styled from 'styled-components';
export var Title = styled.div.withConfig({
  displayName: "style__Title",
  componentId: "rpxy7z-0"
})(["height:100%;width:100%;margin:auto;display:inline-block;vertical-align:middle;font-weight:700;color:", ";"], function (props) {
  return props.dark ? 'rgb(59, 51, 46)' : 'white';
});